import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { BLUE, WHITE } from '../../Styles';
import { StyledButton } from './../Styles';

export const SetDefaultsButton = observer(() => {
  const {
    DebuggerStore: { handleDefaultSettings },
  } = useStores();

  return (
    <StyledButton
      bgColor={BLUE}
      color={WHITE}
      onClick={handleDefaultSettings}
      style={{ cursor: 'pointer' }}
    >
      Default Settings
    </StyledButton>
  );
});

export default SetDefaultsButton;
